import { useEffect, useState } from 'react';
import { 
    UsersIcon, 
    HomeModernIcon, 
    DocumentTextIcon,
    ChartBarIcon
} from '@heroicons/react/24/outline';

export default function DashboardAdmin() {
    const [stats, setStats] = useState({
        totalUsers: 0,
        totalBiens: 0,
        totalContrats: 0,
        totalProprietaires: 0
    });

    useEffect(() => {
        // Ici vous pouvez charger les statistiques depuis votre API
        // Exemple de données statiques pour le moment
        setStats({
            totalUsers: 45,
            totalBiens: 128,
            totalContrats: 95,
            totalProprietaires: 32
        });
    }, []);

    const statCards = [
        { 
            title: 'Utilisateurs totaux', 
            value: stats.totalUsers, 
            icon: UsersIcon, 
            color: 'bg-blue-500',
            textColor: 'text-blue-600',
            bgLight: 'bg-blue-50'
        },
        { 
            title: 'Biens gérés', 
            value: stats.totalBiens, 
            icon: HomeModernIcon, 
            color: 'bg-green-500',
            textColor: 'text-green-600',
            bgLight: 'bg-green-50'
        },
        { 
            title: 'Contrats actifs', 
            value: stats.totalContrats, 
            icon: DocumentTextIcon, 
            color: 'bg-purple-500',
            textColor: 'text-purple-600',
            bgLight: 'bg-purple-50'
        },
        { 
            title: 'Propriétaires', 
            value: stats.totalProprietaires, 
            icon: ChartBarIcon, 
            color: 'bg-orange-500',
            textColor: 'text-orange-600',
            bgLight: 'bg-orange-50'
        }
    ];

    return (
        <div className="p-6 space-y-6">
            {/* En-tête */}
            <div className="mb-6">
                <h1 className="text-3xl font-bold text-gray-900">Dashboard Administrateur</h1>
                <p className="mt-2 text-gray-600">Vue d'ensemble de la plateforme</p>
            </div>

            {/* Cartes de statistiques */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {statCards.map((stat, index) => (
                    <div key={index} className={`${stat.bgLight} rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow`}>
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-sm font-medium text-gray-600">{stat.title}</p>
                                <p className={`text-3xl font-bold mt-2 ${stat.textColor}`}>{stat.value}</p>
                            </div>
                            <div className={`${stat.color} p-3 rounded-lg`}>
                                <stat.icon className="h-8 w-8 text-white" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Actions rapides */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">Actions rapides</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <button className="flex items-center justify-center p-4 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition-colors">
                        <UsersIcon className="h-5 w-5 mr-2" />
                        Gérer les utilisateurs
                    </button>
                    <button className="flex items-center justify-center p-4 bg-green-50 text-green-700 rounded-lg hover:bg-green-100 transition-colors">
                        <HomeModernIcon className="h-5 w-5 mr-2" />
                        Voir tous les biens
                    </button>
                    <button className="flex items-center justify-center p-4 bg-purple-50 text-purple-700 rounded-lg hover:bg-purple-100 transition-colors">
                        <DocumentTextIcon className="h-5 w-5 mr-2" />
                        Rapports globaux
                    </button>
                </div>
            </div>

            {/* Activité récente */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">Activité récente</h2>
                <div className="space-y-3">
                    <div className="flex items-center p-3 bg-gray-50 rounded-lg">
                        <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                        <p className="text-sm text-gray-700">Nouveau propriétaire inscrit</p>
                        <span className="ml-auto text-xs text-gray-500">Il y a 2h</span>
                    </div>
                    <div className="flex items-center p-3 bg-gray-50 rounded-lg">
                        <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                        <p className="text-sm text-gray-700">Nouveau contrat créé</p>
                        <span className="ml-auto text-xs text-gray-500">Il y a 5h</span>
                    </div>
                    <div className="flex items-center p-3 bg-gray-50 rounded-lg">
                        <div className="w-2 h-2 bg-orange-500 rounded-full mr-3"></div>
                        <p className="text-sm text-gray-700">Paiement reçu</p>
                        <span className="ml-auto text-xs text-gray-500">Il y a 1j</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
